// Commit & Checkout scenario - 7 frames synced with ClaudeAnimation

export const commitCheckoutScenario = {
  id: 'commit-checkout',
  title: 'Commit & Checkout',
  description: 'Checkpoint, fail, restore, and retry',
  frames: [
    {
      step: 1,
      label: 'Working',
      ascii: `┌──────────────────────────────────────┐
│                                      │
│                                      │
│   State A                            │
│      │                               │
│      v                               │
│   working...                         │
│                                      │
└──────────────────────────────────────┘`,
    },
    {
      step: 2,
      label: 'Prepare Checkpoint',
      ascii: `┌──────────────────────────────────────┐
│                                      │
│                                      │
│   State A                            │
│      │                               │
│      v                               │
│   [save point?]                      │
│                                      │
└──────────────────────────────────────┘`,
    },
    {
      step: 3,
      label: 'Checkpoint Created',
      ascii: `┌──────────────────────────────────────┐
│                                      │
│   [checkpoint]                       │
│        │                             │
│        v                             │
│     State A ──────────────── saved   │
│                                      │
│                                      │
└──────────────────────────────────────┘`,
    },
    {
      step: 4,
      label: 'Progress Failed',
      ascii: `┌──────────────────────────────────────┐
│                                      │
│   [checkpoint]                       │
│        │                             │
│        v                             │
│     State A --> State B (FAILED!)    │
│                    x                 │
│                                      │
└──────────────────────────────────────┘`,
    },
    {
      step: 5,
      label: 'Need Rollback',
      ascii: `┌──────────────────────────────────────┐
│                                      │
│   [checkpoint] <-- rollback here     │
│        │                             │
│        v                             │
│     State A --> State B (FAILED!)    │
│                    x                 │
│                                      │
└──────────────────────────────────────┘`,
    },
    {
      step: 6,
      label: 'Restoring...',
      ascii: `┌──────────────────────────────────────┐
│                                      │
│   [checkpoint]                       │
│        │                             │
│        v                             │
│     State A --> State B (FAILED!)    │
│        │                             │
│        └──> restoring...             │
└──────────────────────────────────────┘`,
    },
    {
      step: 7,
      label: 'Restored!',
      ascii: `┌──────────────────────────────────────┐
│                                      │
│   [checkpoint]                       │
│        │                             │
│        v                             │
│     State A --> State B (FAILED!)    │
│        │                             │
│        └──> State A' ──> SUCCESS!    │
└──────────────────────────────────────┘`,
    },
  ],
}
